import { Navigate, useLocation, useParams } from "react-router-dom";
import { urls } from "../../../../urls";

export const LegacyWizardRedirect = () => {
  const { eventId } = useParams();
  const location = useLocation();
  if (!eventId) return <Navigate to={urls.v2.sourcingEvents.viewAll} replace />;
  const { pathname } = urls.v2.sourcingEvents.edit.go(eventId).info;
  return <Navigate to={`${pathname}${location.search}${location.hash}`} replace />;
};
